module.exports = {"apiKey":"AIzaSyAqyxN1AvDTzRxroZBPFMMoRiDN-lWx6QI","authDomain":"wagm-staging.firebaseapp.com","databaseURL":"https://wagm-staging.firebaseio.com","projectId":"wagm-staging","storageBucket":"wagm-staging.appspot.com","messagingSenderId":"554518278336"}


//////////////////
// WEBPACK FOOTER
// ./src/config/firebase/staging.json
// module id = 4604
// module chunks = 0